module.exports = __webpack_public_path__ + "879471594ecce36053d7d6bac93e716b.MP3";